var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "450",
      "height": "330",
      "viewBox": "0 0 450 330"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "prefix__a",
      "d": "M193.104 150.156H206.703V281.13300000000004H193.104z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__b",
      "d": "M49.23 281.133H204.17399999999998V285.65099999999995H49.23z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__c",
      "d": "M47.061 150.147H193.104V281.124H47.061z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__d",
      "d": "M51.507 218.349H188.667V241.73999999999998H51.507z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__e",
      "d": "M51.507 248.958H188.667V272.349H51.507z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__h",
      "d": "M51.507 157.374H188.667V180.765H51.507z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__i",
      "d": "M51.507 187.74H188.667V211.131H51.507z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__l",
      "d": "M267.39 206.811H275.95799999999997V285.66H267.39z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__m",
      "d": "M265.113 206.811H270.153V285.66H265.113z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__n",
      "d": "M303.84 206.811H312.40799999999996V285.66H303.84z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__o",
      "d": "M302.238 206.811H307.278V285.66H302.238z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__p",
      "d": "M263.547 206.811H348.723V215.739H263.547z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__q",
      "d": "M377.928 193.185c-4.158 1.575-10.962 11.592-16.533 13.626h-18.387c-5.58-2.034-12.375-12.051-16.533-13.626 8.558-.672 17.152-.756 25.722-.252 8.573-.504 17.17-.42 25.731.252z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__r",
      "d": "M385.893 206.811H394.46099999999996V285.66H385.893z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__s",
      "d": "M384.291 206.811H389.331V285.66H384.291z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__t",
      "d": "M352.386 206.811H395.99100000000004V215.739H352.386z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__u",
      "d": "M349.443 206.811H358.01099999999997V285.66H349.443z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__v",
      "d": "M347.157 206.811H352.197V285.66H347.157z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__w",
      "d": "M82.296 0.414H384.534V91.755H82.296z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__x",
      "d": "M74.052 0.414H382.617V91.755H74.052z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__y",
      "d": "M82.296 91.764L384.534 91.764 384.534 98.298 78.444 98.298z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__z",
      "d": "M67.248 91.764L375.813 91.764 374.031 98.298 65.466 98.298z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__A",
      "d": "M194.202 -96.66H262.467V188.82899999999998H194.202z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__B",
      "d": "M52.191 45.351H120.456V46.818H52.191z"
    }
  }), _c('path', {
    attrs: {
      "id": "prefix__C",
      "d": "M35.604 46.107c-.963-2.295-1.854-5.13.054-5.724 1.908-.594 6.39 1.278 11.115.315 4.725-.963 9.261-.9 10.8 1.44.864 1.153 1.266 2.589 1.125 4.023l-23.094-.054z"
    }
  }), _c('rect', {
    attrs: {
      "id": "prefix__f",
      "width": "115.542",
      "height": "3.204",
      "x": "62.307",
      "y": "216.918",
      "rx": "1.125"
    }
  }), _c('rect', {
    attrs: {
      "id": "prefix__g",
      "width": "115.542",
      "height": "3.204",
      "x": "62.307",
      "y": "247.527",
      "rx": "1.125"
    }
  }), _c('rect', {
    attrs: {
      "id": "prefix__j",
      "width": "115.542",
      "height": "3.204",
      "x": "62.307",
      "y": "155.943",
      "rx": "1.125"
    }
  }), _c('rect', {
    attrs: {
      "id": "prefix__k",
      "width": "115.542",
      "height": "3.204",
      "x": "62.307",
      "y": "186.309",
      "rx": "1.125"
    }
  })]), _c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M0 285.66H450V286.66H0zM357.147 300.141H404.90999999999997V301.141H357.147zM245.304 297.324H298.098V298.324H245.304zM342.18 296.028H359.451V297.028H342.18zM90.423 293.301H129.294V294.301H90.423zM71.514 293.301H85.41V294.301H71.514zM118.323 297.099H167.103V298.099H118.323z"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(180 199.904 215.644)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__a"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__a"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 126.702 283.392)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__b"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__b"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__c"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".1",
      "xlink:href": "#prefix__c"
    }
  }), _c('g', {
    attrs: {
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ABCDFF",
      "d": "M12.931 0c.511 1.486.752 3.051.71 4.622-.058 1.563-.285 3.116-.676 4.631-.112.427-.236.85-.37 1.27.273-.58.543-1.159.808-1.737.647-1.41 1.27-2.826 1.849-4.262.579-1.435 1.075-2.919 1.561-4.446.15 1.615.034 3.244-.345 4.821-.384 1.568-.916 3.096-1.59 4.563l-.154.323c.434-.59.863-1.183 1.282-1.787.885-1.275 1.693-2.588 2.515-3.98-.215 1.608-.694 3.17-1.416 4.622l-.003.01c.409-.583.805-1.174 1.19-1.77.764-1.183 1.46-2.433 2.21-3.727-.11 1.495-.479 2.96-1.09 4.33-.15.336-.31.669-.48.996l-.005.085.533-.843c.224-.287.462-.56.7-.832l.365-.404.4-.35.817-.686c.577-.401 1.177-.77 1.795-1.105.634-.287 1.284-.54 1.946-.758-.487.515-.973.973-1.494 1.41-.52.438-.943.94-1.4 1.401-.215.253-.424.487-.643.735l-.326.355-.277.39c-.185.257-.39.486-.57.758l-.486.803c-.1.176-.195.355-.285.536.147-.16.302-.313.465-.458.243-.238.52-.428.778-.642.257-.213.53-.405.818-.574.282-.166.564-.336.856-.487.141-.078.282-.165.433-.233l.448-.19c.301-.127.603-.243.904-.36.3-.121.61-.219.925-.292.627-.163 1.262-.293 1.902-.39-.503.4-1.028.77-1.571 1.11-.268.16-.52.34-.774.525-.253.185-.486.35-.769.521-.53.316-.973.72-1.46 1.06-.242.17-.473.358-.69.56-.224.195-.486.37-.671.574-.843.745-1.508 1.67-1.946 2.705-.093.26-.168.527-.224.798-.045.282-.068.566-.068.851 0 .614.105 1.223.311 1.8-.247-.212-.462-.456-.642-.724.032.242.073.484.122.724-.305-.397-.562-.825-.767-1.275l-5.698.112c-.716.516-1.473.975-2.263 1.373l.014-.017c-.605.513-1.236.993-1.892 1.438-.075.14-.157.276-.248.408l.033-.264c-.29.192-.585.377-.885.556l.575-.774.075-.1.086-.18c.057-.129.11-.259.16-.39-.022-.283-.063-.565-.127-.843-.129-.626-.33-1.235-.598-1.815-.545-1.163-1.237-2.252-2.058-3.24-.185-.267-.423-.486-.633-.744-.209-.258-.423-.486-.647-.744-.486-.487-.905-.973-1.386-1.46-.482-.486-.944-.973-1.43-1.46C.973 6.948.486 6.462 0 5.93c.657.249 1.28.555 1.912.866.614.338 1.21.706 1.785 1.105.29.199.57.413.837.642.273.224.54.457.808.686.518.49 1.006 1.011 1.46 1.562.869 1.047 1.52 2.256 1.915 3.557-.122-.893-.386-1.762-.782-2.575l-.166-.394L7.56 11l-.408-.768c-.326-.486-.618-1.007-.973-1.508-.356-.501-.677-1.002-1.037-1.503-.378-.504-.73-1.027-1.055-1.567.56.308 1.102.646 1.625 1.012.51.388.997.806 1.459 1.25.23.226.447.467.647.72.208.25.412.503.613.76l.52.841.249.428.204.457c.17.354.31.72.418 1.093.012-.866-.094-1.731-.316-2.572-.151-.564-.363-1.11-.632-1.63-.268-.535-.584-1.044-.944-1.522-.775-1.012-1.623-1.965-2.54-2.851 1.304.386 2.499 1.073 3.489 2.004.516.475.964 1.019 1.333 1.616.38.603.668 1.258.856 1.946.043.16.08.32.112.483l.219-.814c.38-1.44.695-2.89.973-4.379.277-1.488.428-2.919.56-4.495z",
      "transform": "translate(63 120)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#EEF5FF",
      "d": "M3.002 14.936L23.23 14.936 20.579 29.964 5.653 29.964z",
      "transform": "translate(63 120)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#DEEBFF",
      "d": "M15.636 14.936L23.23 14.936 20.579 29.964 16.595 29.964z",
      "transform": "translate(63 120)"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__d"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__d"
    }
  }), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__e"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__e"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(180 120.078 218.52)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__f"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".1",
      "xlink:href": "#prefix__f"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 120.078 249.129)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__g"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".1",
      "xlink:href": "#prefix__g"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__h"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__h"
    }
  }), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__i"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__i"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(180 120.078 157.545)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__j"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".1",
      "xlink:href": "#prefix__j"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 120.078 187.911)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__k"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".1",
      "xlink:href": "#prefix__k"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 271.674 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__l"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__l"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 267.633 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__m"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__m"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 308.124 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__n"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__n"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 304.758 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__o"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__o"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__p"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__p"
    }
  }), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__q"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__q"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(180 390.177 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__r"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__r"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 386.811 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__s"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__s"
    }
  })]), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__t"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__t"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(180 353.727 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__u"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__u"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 349.677 246.236)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__v"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__v"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(180 233.415 46.084)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__w"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__w"
    }
  })]), _c('g', {
    attrs: {
      "fill-rule": "nonzero",
      "transform": "rotate(180 228.334 46.084)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__x"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__x"
    }
  })]), _c('g', [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__y"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__y"
    }
  })]), _c('g', {
    attrs: {
      "fill-rule": "nonzero"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__z"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".2",
      "xlink:href": "#prefix__z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "rotate(90 228.334 46.085)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__A"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".7",
      "xlink:href": "#prefix__A"
    }
  })]), _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M329.832 80.217L291.195 11.961 254.304 11.961 292.941 80.217zM285.012 80.217L246.384 11.961 232.002 11.961 270.63 80.217z",
      "opacity": ".3"
    }
  }), _c('g', {
    attrs: {
      "transform": "rotate(90 86.323 46.085)"
    }
  }, [_c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__B"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "fill-opacity": ".5",
      "xlink:href": "#prefix__B"
    }
  })]), _c('ellipse', {
    attrs: {
      "cx": "214",
      "cy": "319.116",
      "fill": "#DDEBFF",
      "fill-rule": "nonzero",
      "rx": "174.501",
      "ry": "10.188"
    }
  }), _c('g', [_c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M186.768 146.448H7.668c-4.275 0-7.47-4.248-7.11-9.441L9.099 13.788c.36-5.193 4.149-9.441 8.415-9.441h179.1c4.266 0 7.461 4.248 7.101 9.441l-8.541 123.219c-.351 5.193-4.14 9.441-8.406 9.441z",
      "transform": "translate(169.3 40.6)"
    }
  }), _c('g', [_c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M31.764 0H55.1c2.412 0 4.268 1.955 4.145 4.367L58.061 27.66c-.122 2.412-2.177 4.368-4.59 4.368H30.137c-2.412 0-4.268-1.956-4.146-4.368l1.185-23.293C27.297 1.955 29.352 0 31.765 0z",
      "transform": "translate(169.3 40.6) translate(56.7 39.6)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M41.024 4.367c1.692 2.871 4.84 4.697 8.412 4.697l.374-.006.372-.02c.495-.035.987-.105 1.471-.21l.073-.018-.025.593c-.114 2.332-.355 4.67-.696 6.362-.264 1.314-.595 2.448-.993 3.396-1.656 3.945-4.673 6.737-9.2 8.5 2.86-4.848 2.813-8.881-.188-12.019l-.155-.165c-2.732-2.99-2.6-6.604.44-10.947l.115-.163zM36.64 18.925c1.61 0 2.85 1.304 2.767 2.912-.081 1.608-1.453 2.912-3.063 2.912s-2.85-1.304-2.768-2.912c.082-1.608 1.454-2.912 3.064-2.912z",
      "transform": "translate(169.3 40.6) translate(56.7 39.6)"
    }
  }), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M5.768 61.895c3.25 0 5.913-1.424 6.064-4.4.116-2.278-1.186-3.701-3.895-3.96l-2.156-.207c-1.21-.103-1.393-.673-1.368-1.164.034-.673.647-1.294 2.021-1.294 1.19 0 2.395.207 3.152.905l2.22-2.096C10.547 48.463 8.768 48.1 6.628 48.1c-2.801 0-5.388 1.501-5.53 4.296-.127 2.485 1.352 3.546 3.824 3.78l2.157.206c1.078.104 1.424.57 1.39 1.242-.051 1.01-1.313 1.398-2.502 1.398-1.057 0-2.53-.155-3.609-1.268L0 59.954c1.657 1.708 3.601 1.94 5.768 1.94zm11.577-.026c1.585 0 2.477-.388 3.448-1.294l-.059 1.164h3.356l.451-8.877c.161-3.157-1.766-4.762-5.624-4.762-2.3 0-3.642.414-5.063 1.864l2.087 2.096c.754-.802 1.378-1.113 2.699-1.113 1.823 0 2.53.647 2.456 2.122l-.035.673h-3.25c-3.198 0-4.794 1.76-4.903 3.908-.06 1.19.28 2.278.983 3.028.778.803 1.895 1.19 3.454 1.19zm.774-2.744c-1.348 0-1.95-.62-1.903-1.552.048-.958.764-1.527 2.006-1.527h2.722l-.037.724c-.042.829-.202 1.372-.589 1.708-.636.57-1.248.647-2.2.647zm12.71 2.614l.536-10.533h2.537l.13-2.562h-2.537l.075-1.475c.04-.777.432-1.217 1.251-1.217h1.348l.145-2.847h-1.956c-2.8 0-4.115 1.941-4.212 3.857l-.086 1.682h-1.427l-.13 2.562h1.427l-.536 10.533h3.436zm9.613.156c2.484 0 3.87-.75 5.34-2.122l-1.986-1.993c-.916.854-1.677 1.268-3.183 1.268-1.93 0-2.948-1.268-2.86-3.002h8.615l.076-1.501c.188-3.701-1.84-6.445-5.67-6.445-3.569 0-6.126 2.485-6.35 6.885-.277 5.46 2.767 6.91 6.018 6.91zm2.66-8.153H37.87c.057-.595.154-.957.39-1.449.412-.802 1.208-1.398 2.37-1.398 1.164 0 1.9.596 2.229 1.398.186.492.247.854.243 1.45zm11.513 7.997l.145-2.846h-1.242c-.82 0-1.167-.44-1.128-1.217l.33-6.47h2.43l.13-2.562h-2.43l.202-3.986h-3.435l-.203 3.986h-1.453l-.13 2.562h1.453l-.34 6.677c-.097 1.915.993 3.856 3.795 3.856h1.876zm7.894.156c2.484 0 3.87-.75 5.34-2.122l-1.986-1.993c-.915.854-1.676 1.268-3.183 1.268-1.929 0-2.948-1.268-2.86-3.002h8.615l.077-1.501c.188-3.701-1.84-6.445-5.671-6.445-3.568 0-6.126 2.485-6.35 6.885-.277 5.46 2.768 6.91 6.018 6.91zm2.661-8.153h-5.232c.056-.595.154-.957.39-1.449.411-.802 1.208-1.398 2.37-1.398 1.163 0 1.9.596 2.229 1.398.186.492.247.854.243 1.45zm11.002 8.153c2.485 0 3.87-.75 5.34-2.122l-1.986-1.993c-.915.854-1.676 1.268-3.182 1.268-1.93 0-2.949-1.268-2.86-3.002h8.615l.076-1.501c.188-3.701-1.84-6.445-5.671-6.445-3.568 0-6.125 2.485-6.349 6.885-.278 5.46 2.767 6.91 6.017 6.91zm2.661-8.153h-5.232c.056-.595.154-.957.39-1.449.411-.802 1.208-1.398 2.37-1.398 1.163 0 1.9.596 2.229 1.398.186.492.247.854.243 1.45z",
      "transform": "translate(169.3 40.6) translate(56.7 39.6)"
    }
  })]), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "fill-rule": "nonzero",
      "d": "M171.126 1.656h-5.04v-.81h5.04v.81zm-8.901 0h-18.414v-.81h18.414v.81zM188.1 146.835H7.425c-4.455 0-7.776-4.41-7.398-9.828L8.568 13.788c.378-5.4 4.311-9.837 8.766-9.837H198c4.5 0 7.776 4.41 7.398 9.837l-8.541 123.219c-.351 5.418-4.257 9.828-8.757 9.828zM17.523 4.734c-4.104 0-7.713 4.059-8.1 9.054L.9 137.007c-.351 4.986 2.7 9 6.813 9h179.1c4.104 0 7.722-4.059 8.1-9L203.4 13.788c.351-4.995-2.7-9.054-6.804-9.054H17.523z",
      "transform": "translate(169.3 40.6)"
    }
  })]), _c('g', {
    attrs: {
      "fill-rule": "nonzero",
      "transform": "translate(83.7 16.2)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#B65B52",
      "d": "M31.068 55.152l-6.066 12.042c-1.026 1.989-2.007 3.996-2.979 5.985-.972 1.989-1.899 3.987-2.7 5.85-.189.459-.378.9-.513 1.314-.135.414-.243.819-.243.621v.846l.081 1.404c.21 2.082.525 4.151.945 6.201.828 4.266 3.808 11.39 4.798 15.745l-5.04 2.106c-2.419-4.057-6.36-11.05-8.038-15.466-.888-2.306-1.61-4.673-2.16-7.083-.126-.657-.252-1.305-.351-1.98l-.117-1.08c-.062-.495-.078-.996-.045-1.494.082-.913.248-1.817.495-2.7.189-.702.378-1.314.576-1.926.783-2.412 1.674-4.572 2.574-6.741.9-2.169 1.863-4.275 2.817-6.381 1.962-4.194 3.996-8.289 6.21-12.366l9.756 5.103z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M24.27 104.085l4.177 4.504-7.55 3.571s-3.044-3.757-1.76-7.021l5.132-1.054z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M29.345 113.98l-2.294 1.59c-.906.62-2.122.513-2.908-.253l-3.232-3.171 7.55-3.572 1.498 2.223c.708 1.048.433 2.472-.614 3.182z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M60.3 22.761c-.162.567 0 1.116.369 1.224.369.108.801-.252.963-.819.162-.567 0-1.107-.369-1.224-.369-.117-.765.261-.963.819z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#A02724",
      "d": "M60.3 23.859c.17 1.927.6 3.822 1.278 5.634-.941.32-1.975.208-2.826-.306l1.548-5.328z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M63.063 19.503c.084.107.098.254.036.375-.061.122-.188.196-.324.192-1.095-.05-2.099-.623-2.7-1.539-.063-.106-.064-.238-.003-.345.06-.107.173-.174.297-.175.123-.002.237.063.3.169.486.727 1.295 1.173 2.169 1.197.087.014.167.059.225.126z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M40.86 29.205c.72 4.869.711 10.467-2.349 13.419 0 0 1.521 5.4 11.412 5.4 10.863 0 5.166-4.734 5.166-4.734-4.5-1.404-4.563-6.552-3.6-10.683l-8.622-4.806c-.456-.248-1.013-.217-1.438.08-.426.298-.646.81-.569 1.324z"
    }
  }), _c('use', {
    attrs: {
      "fill": "#FFF",
      "xlink:href": "#prefix__C"
    }
  }), _c('use', {
    attrs: {
      "fill": "#579AFF",
      "xlink:href": "#prefix__C"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M63.063 292.86c.9 0 1.8-.135 2.133-.549.157-.228.157-.528 0-.756-.123-.202-.32-.347-.549-.405-1.215-.324-3.735 1.125-3.843 1.188-.063.031-.097.102-.081.171.01.072.064.13.135.144.728.132 1.465.201 2.205.207zm1.134-1.413c.11-.015.222-.015.333 0 .142.033.265.12.342.243.126.216.081.324 0 .378-.333.477-2.169.486-3.519.297.878-.492 1.845-.804 2.844-.918z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M60.867 292.653h.072c.9-.396 2.583-1.971 2.439-2.79 0-.198-.171-.432-.639-.486-.346-.04-.692.068-.954.297-.9.756-1.089 2.7-1.098 2.799-.002.062.025.122.072.162.034.014.071.02.108.018zm1.737-2.943h.099c.315 0 .333.153.342.198.081.495-1.08 1.728-1.971 2.268.061-.822.376-1.605.9-2.241.173-.153.399-.234.63-.225z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M52.731 292.482L60.003 292.482 60.777 275.643 53.505 275.643z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M60.075 291.645h-7.938c-.295.002-.549.207-.612.495l-1.35 6.462c-.069.319.012.652.219.904.206.252.517.397.843.392 2.862-.054 7.002-.216 10.602-.216 4.203 0 5.031.225 9.972.225 2.988 0 3.771-3.015 2.52-3.294-5.706-1.242-7.542-1.377-12.492-4.401-.524-.35-1.135-.546-1.764-.567zM28.512 43.767C17.613 46.098 13.5 63.423 13.5 63.423l12.357 10.242c4.12-3.494 7.04-8.194 8.343-13.437 2.25-9.126 1.287-17.928-5.688-16.461z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M31.5 57.069c-3.654 3.663-6.03 10.332-6.246 16.128l.612.468c4.116-3.5 7.031-8.202 8.334-13.446.135-.54.243-1.089.342-1.62l-3.042-1.53z",
      "opacity": ".2"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M68.67 51.561c1.593 7.857 2.7 23.985-1.179 55.944H28.593c-.324-5.742 2.781-32.868-2.412-59.94-.167-.875.025-1.78.533-2.512.508-.731 1.289-1.227 2.167-1.376 3.177-.52 6.38-.871 9.594-1.053 5.506-.315 11.027-.315 16.533 0 1.8.171 3.6.432 5.22.711 4.24.742 7.59 4.007 8.442 8.226z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M62.379 67.5l2.583-3.285c5.058 1.638 5.319 6.543 5.04 13.644-4.302-1.116-6.642-5.508-7.623-10.359zM60.777 275.643L60.381 284.328 53.1 284.328 53.505 275.643z",
      "opacity": ".2"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M41.976 15.885c-1.584 7.056-2.871 11.097-.423 15.705 3.69 6.939 13.113 6.345 16.758-.063 3.285-5.769 5.319-16.335-.621-21.132-2.623-2.173-6.191-2.814-9.407-1.691-3.215 1.123-5.608 3.848-6.307 7.181z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M46.485 34.2c-7.821.117-9.981-5.679-9.306-11.223.675-5.544-4.59-8.505-2.124-13.5 1.728-3.519 4.392-3.6 6.498-2.925.963-4.14 7.605-7.704 12.141-4.221 4.536 3.483 10.278 6.552 11.7 4.608 1.422-1.944 4.05 7.722-6.192 11.475.878 1.496.94 3.336.162 4.887-.225.504-2.484.981-2.7 1.503-2.223 4.5-5.625 9.324-10.179 9.396z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M41.319.144c-2.268 6.714 1.179 8.802 1.179 8.802L41.319.144z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M52.677 22.41c-.204 1.786.178 3.59 1.089 5.139 1.224 2.034 3.06 1.305 3.735-.729.612-1.8.711-5.076-1.008-6.417-1.719-1.341-3.528-.135-3.816 2.007zM3.348 289.953L10.314 291.69 14.904 275.265 7.938 273.528z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M13.671 292.041c.9.162 1.8.189 2.115-.18.164-.229.164-.536 0-.765-.109-.225-.294-.403-.522-.504-1.188-.54-3.726.486-3.834.531-.062.028-.096.096-.081.162.009.073.057.136.126.162.712.265 1.447.464 2.196.594zm1.161-1.224c.115.017.227.05.333.099.139.059.253.164.324.297.117.243.072.342 0 .396-.342.414-2.151.108-3.483-.315.898-.357 1.86-.52 2.826-.477z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M11.511 291.456c.023.009.049.009.072 0 .9-.243 2.619-1.539 2.502-2.394 0-.198-.153-.459-.621-.594-.305-.089-.634-.04-.9.135-.9.603-1.161 2.556-1.17 2.637-.007.064.017.127.063.171.014.02.033.035.054.045zm1.8-2.7h.108c.306.081.315.207.324.252.063.513-1.125 1.557-2.016 1.953.08-.794.43-1.537.99-2.106.184-.1.4-.126.603-.072l-.009-.027z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M10.719 290.295L2.898 288.9c-.283-.054-.562.112-.648.387l-1.935 6.219c-.095.316-.051.657.12.939.172.282.456.477.78.537 2.817.45 6.912.999 10.458 1.629 4.149.729 1.107.423 5.976 1.278 2.934.522 3.996-2.358 2.79-2.853-5.499-2.232-5.985-3.42-8.1-5.895-.43-.456-1-.755-1.62-.846z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M14.904 275.265L12.537 283.734 5.562 281.997 7.929 273.528z",
      "opacity": ".2"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M53.694 107.505s-9.135 58.419-13.779 79.146c-5.085 22.707-23.778 93.735-23.778 93.735L3.51 277.2s10.242-57.069 14.571-88.866c3.33-24.426 10.512-80.82 10.512-80.82l25.101-.009z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M18.9 277.785c.063 0-1.89 4.788-1.89 4.788l-15.048-3.834.657-4.5 16.281 3.546z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#000",
      "d": "M46.557 133.389c-9.153 1.215-7.2 36-7.02 54.963 0-.198.081-.405.135-.603.072-.378.162-.747.243-1.098 2.574-11.493 6.525-34.56 9.54-52.839-.957-.194-1.925-.336-2.898-.423z",
      "opacity": ".3"
    }
  }), _c('path', {
    attrs: {
      "fill": "#579AFF",
      "d": "M67.5 107.505s-.234 54.369-.747 76.545c-.522 23.067-3.672 98.595-3.672 98.595h-12.33s-4.032-74.178-4.869-96.831c-.9-24.696-3.96-78.3-3.96-78.3l25.578-.009z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M65.376 277.74c.063 0-.63 5.112-.63 5.112H49.761l-.459-4.563 16.074-.549z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B65B52",
      "d": "M67.617 49.671c1.863 2.304 3.645 4.671 5.4 7.092 1.755 2.421 3.411 4.923 4.977 7.506 1.612 2.602 3.09 5.284 4.428 8.037 1.418 2.868 2.572 5.86 3.447 8.937l.297 1.035-.081.729c-.26 2.161-.694 4.298-1.296 6.39-.54 2.016-1.224 3.924-1.926 5.814-.702 1.89-1.503 3.735-2.34 5.544-.837 1.809-3.294 6.819-4.32 8.619l-5.085-1.98 2.709-8.817c.369-1.863.756-3.726 1.08-5.562.324-1.836.648-3.672.9-5.454.24-1.69.372-3.395.396-5.103l.216 1.8c-.92-2.43-2.024-4.785-3.303-7.047-1.305-2.358-2.772-4.68-4.293-6.993-1.521-2.313-3.15-4.599-4.797-6.867-1.647-2.268-3.375-4.5-5.058-6.795l8.649-6.885z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#263238",
      "d": "M52.362 52.2c-.072 10.485 11.16 20.988 11.16 20.988L77.841 61.2c-1.82-5.494-5.19-10.344-9.702-13.968-9.81-7.929-15.723-2.637-15.777 4.968z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M74.304 58.986c.044.288-.036.58-.22.807-.183.226-.453.364-.743.381-.623-.05-1.109-.563-1.125-1.188-.046-.29.032-.584.216-.812.183-.229.455-.368.747-.385.627.05 1.113.568 1.125 1.197zM64.197 54.333c.046.29-.032.584-.216.812-.183.229-.455.368-.747.385-.627-.05-1.113-.568-1.125-1.197-.044-.288.036-.58.22-.807.183-.226.453-.364.743-.381.623.05 1.109.563 1.125 1.188zM65.025 66.231c.043.289-.036.582-.219.81-.183.227-.453.368-.744.387-.625-.055-1.11-.57-1.125-1.197-.043-.289.036-.582.219-.81.183-.227.453-.368.744-.387.625.055 1.11.57 1.125 1.197zM65.853 78.12c.043.289-.036.582-.219.81-.183.227-.453.368-.744.387-.625-.055-1.11-.57-1.125-1.197-.044-.288.036-.58.22-.807.183-.226.453-.364.743-.381.623.05 1.109.563 1.125 1.188zM66.681 90c.044.288-.036.58-.22.807-.183.226-.453.364-.743.381-.623-.05-1.109-.563-1.125-1.188-.046-.29.032-.584.216-.812.183-.229.455-.368.747-.385.627.05 1.113.568 1.125 1.197zM64.854 101.871c.044.288-.036.58-.22.807-.183.226-.453.364-.743.381-.623-.05-1.109-.563-1.125-1.188-.046-.288.03-.581.213-.81.181-.227.45-.368.741-.387.628.05 1.118.567 1.134 1.197zM53.244 46.413c.044.288-.036.58-.22.807-.183.226-.453.364-.743.381-.623-.05-1.109-.563-1.125-1.188-.046-.29.032-.584.216-.812.183-.229.455-.368.747-.385.627.05 1.113.568 1.125 1.197zM54.072 58.302c.043.289-.036.582-.219.81-.183.227-.453.368-.744.387-.625-.055-1.11-.57-1.125-1.197-.043-.289.036-.582.219-.81.183-.227.453-.368.744-.387.625.055 1.11.57 1.125 1.197zM54.9 70.2c.046.29-.032.584-.216.812-.183.229-.455.368-.747.385-.627-.05-1.113-.568-1.125-1.197-.044-.288.036-.58.22-.807.183-.226.453-.364.743-.381.623.05 1.109.563 1.125 1.188zM55.728 82.089c.044.288-.036.58-.22.807-.183.226-.453.364-.743.381-.623-.05-1.109-.563-1.125-1.188-.046-.29.032-.584.216-.812.183-.229.455-.368.747-.385.627.05 1.113.568 1.125 1.197zM56.556 93.978c.046.29-.032.584-.216.812-.183.229-.455.368-.747.385-.625-.055-1.11-.57-1.125-1.197-.043-.289.036-.582.219-.81.183-.227.453-.368.744-.387.625.055 1.11.57 1.125 1.197zM46.71 101.907c-.016-.627-.5-1.142-1.125-1.197-.291.02-.561.16-.744.387-.183.228-.262.521-.219.81.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM45.9 90c-.012-.629-.498-1.146-1.125-1.197-.292.017-.564.156-.747.385-.184.228-.262.523-.216.812.016.625.502 1.138 1.125 1.188.29-.017.56-.155.744-.381.183-.227.263-.52.219-.807zM45.054 78.12c-.016-.625-.502-1.138-1.125-1.188-.29.017-.56.155-.744.381-.183.227-.263.52-.219.807.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM44.226 66.231c-.016-.627-.5-1.142-1.125-1.197-.291.02-.561.16-.744.387-.183.228-.262.521-.219.81.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM43.398 54.333c-.016-.625-.502-1.138-1.125-1.188-.29.017-.56.155-.744.381-.183.227-.263.52-.219.807.012.629.498 1.146 1.125 1.197.292-.017.564-.156.747-.385.184-.228.262-.523.216-.812zM35.757 93.978c-.016-.627-.5-1.142-1.125-1.197-.291.02-.561.16-.744.387-.183.228-.262.521-.219.81.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM34.929 82.089c-.012-.629-.498-1.146-1.125-1.197-.292.017-.564.156-.747.385-.184.228-.262.523-.216.812.016.625.502 1.138 1.125 1.188.29-.017.56-.155.744-.381.183-.227.263-.52.219-.807zM34.101 70.2c-.016-.625-.502-1.138-1.125-1.188-.29.017-.56.155-.744.381-.183.227-.263.52-.219.807.012.629.498 1.146 1.125 1.197.292-.017.564-.156.747-.385.184-.228.262-.523.216-.812zM33.3 58.302c-.016-.627-.5-1.142-1.125-1.197-.291.02-.561.16-.744.387-.183.228-.262.521-.219.81.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM32.445 46.413c-.012-.629-.498-1.146-1.125-1.197-.292.017-.564.156-.747.385-.184.228-.262.523-.216.812.016.625.502 1.138 1.125 1.188.29-.017.56-.155.744-.381.183-.227.263-.52.219-.807zM23.4 66.231c-.016-.627-.5-1.142-1.125-1.197-.291.02-.561.16-.744.387-.183.228-.262.521-.219.81.016.627.5 1.142 1.125 1.197.291-.02.561-.16.744-.387.183-.228.262-.521.219-.81zM22.599 54.333c-.016-.625-.502-1.138-1.125-1.188-.29.017-.56.155-.744.381-.183.227-.263.52-.219.807.01.616.476 1.13 1.089 1.197.299-.007.58-.142.771-.372.192-.229.275-.53.228-.825z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#B55B52",
      "d": "M76.443 108.8l-4.548-1.645c-5.162 1.24-5.501 6.426-5.501 6.426l-.794 2.296c-.197.568-.157 1.192.111 1.73.27.538.744.945 1.316 1.129l3.78 1.22c.897.29 1.88-.018 2.452-.769l.408-.529c1.422-1.843 2.288-4.054 2.497-6.373l.279-3.485z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }